import { render, staticRenderFns } from "./form_parm.vue?vue&type=template&id=6a5f9f4e&scoped=true&"
import script from "./form_parm.vue?vue&type=script&lang=js&"
export * from "./form_parm.vue?vue&type=script&lang=js&"
import style0 from "./form_parm.vue?vue&type=style&index=0&id=6a5f9f4e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5f9f4e",
  null
  
)

export default component.exports